import { render, staticRenderFns } from "./TableMatrixV2.vue?vue&type=template&id=3d2f0efd&scoped=true"
import script from "./TableMatrixV2.vue?vue&type=script&lang=js"
export * from "./TableMatrixV2.vue?vue&type=script&lang=js"
import style0 from "./TableMatrixV2.vue?vue&type=style&index=0&id=3d2f0efd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f0efd",
  null
  
)

export default component.exports